export const API_CONSTANTS = Object.freeze({
  BASE_API_URL: "https://aliyunportal.henkel.cn/portalv2/",
  // BASE_API_URL: "/portalv2/",
  DATETIME_FROM_START_TIME: " 00:00:00.000",
  DATETIME_TO_END_TIME: " 23:59:59.999",
});
